export const Shape1 = () => (
  <svg
    width="64"
    height="58"
    viewBox="0 0 64 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.28069 29.1979C8.9997 21.0695 20.2295 19.1159 28.3584 24.8391C36.4873 30.5577 38.4408 41.787 32.7174 49.9154C26.9984 58.0438 15.7686 59.9973 7.63969 54.2742C-0.48919 48.5555 -2.43832 37.3263 3.28069 29.1979Z"
      fill="#F8AB5D"
    />
    <path
      d="M35.5716 0.000657065C50.7461 0.000655739 63.0898 12.3445 63.0898 27.5189C63.0898 42.6934 50.7461 55.0371 35.5716 55.0371C20.3972 55.0371 8.05334 42.6934 8.05334 27.5189C8.05032 12.3445 20.3972 0.000658392 35.5716 0.000657065ZM35.5716 51.0102C48.5256 51.0102 59.0629 40.473 59.0629 27.5189C59.0629 14.5649 48.5226 4.02767 35.5716 4.02767C22.6206 4.02767 12.0803 14.5649 12.0804 27.5189C12.0773 40.473 22.6176 51.0102 35.5716 51.0102Z"
      fill="#3D3D3D"
    />
  </svg>
);

export const Shape2 = () => (
  <svg
    width="157"
    height="161"
    viewBox="0 0 157 161"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M99.35 177.68C132.06 188.231 167.13 170.268 177.681 137.558C188.232 104.848 170.268 69.7783 137.559 59.2273C104.849 48.6763 69.7788 66.6396 59.2278 99.3495C48.6768 132.059 66.6402 167.129 99.35 177.68Z"
      fill="#F8AB5D"
    />
    <path
      d="M109.703 42.5705L110.23 42.3869C110.054 42.4481 109.878 42.5066 109.703 42.5705Z"
      fill="#3D3D3D"
    />
    <path
      d="M181.201 74.4695L74.745 111.598C75.3956 113.798 76.1923 115.976 77.1278 118.125L183.41 81.0577C182.816 78.839 182.083 76.639 181.201 74.4695Z"
      fill="#3D3D3D"
    />
    <path
      d="M184.751 87.4402L80.0755 123.947C81.2896 126.043 82.6069 128.042 84.0398 129.923L185.322 94.5989C185.28 92.2151 185.101 89.8237 184.751 87.4402Z"
      fill="#3D3D3D"
    />
    <path
      d="M185.023 101.554L88.6062 135.181C90.4813 137.094 92.4743 138.855 94.5713 140.459L183.631 109.398C184.278 106.823 184.743 104.202 185.023 101.554Z"
      fill="#3D3D3D"
    />
    <path
      d="M174.6 62.5614L72.4969 98.1712C72.6008 100.535 72.8667 102.901 73.2733 105.259L178.417 68.5883C177.26 66.4721 175.978 64.468 174.6 62.5614Z"
      fill="#3D3D3D"
    />
    <path
      d="M181.082 117.138L101.39 144.933C104.356 146.584 107.455 147.969 110.653 149.061L176.406 126.129C178.237 123.267 179.801 120.259 181.082 117.138Z"
      fill="#3D3D3D"
    />
    <path
      d="M155.788 145.277C160.655 142.639 164.968 139.379 168.705 135.663L122.615 151.738C133.691 152.988 145.245 150.991 155.788 145.277Z"
      fill="#3D3D3D"
    />
    <path
      d="M164.522 51.87L73.7891 83.515C73.2258 86.0674 72.8373 88.6607 72.6311 91.2763L170.254 57.2289C168.459 55.2933 166.54 53.5105 164.522 51.87Z"
      fill="#3D3D3D"
    />
    <path
      d="M149.2 43.006L80.2249 67.0623C78.573 69.8803 77.1858 72.8335 76.0481 75.8768L157.995 47.2963C155.185 45.6098 152.241 44.1773 149.2 43.006Z"
      fill="#3D3D3D"
    />
    <path
      d="M110.23 42.3863L109.703 42.5699C107.091 43.518 104.514 44.6669 101.998 46.0313C96.1857 49.1814 91.1573 53.212 86.9694 57.857L138.184 39.9946C129.004 38.4564 119.398 39.1625 110.23 42.3863Z"
      fill="#3D3D3D"
    />
  </svg>
);

export const Shape3 = () => (
  <svg
    width="108"
    height="132"
    viewBox="0 0 108 132"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M135.728 16.4043H20.1328V132H135.728V16.4043Z" fill="#F8AB5D" />
    <path
      d="M120.069 120.069H0V0H120.069V120.069ZM4.4739 115.593H115.593V4.47394H4.4739V115.593Z"
      fill="#3D3D3D"
    />
  </svg>
);

export const Shape4 = () => (
  <svg
    width="185"
    height="116"
    viewBox="0 0 185 116"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M158 26V120H2V26H158Z" stroke="#242424" stroke-width="4" />
    <path
      d="M181.592 82.7033L184.98 79.3145L171.988 66.3224L168.6 69.7112L181.592 82.7033Z"
      fill="#F8AB5D"
    />
    <path
      d="M184.944 69.7228L181.555 66.334L168.563 79.3261L171.951 82.7149L184.944 69.7228Z"
      fill="#F8AB5D"
    />
    <path
      d="M147.451 82.7052L150.84 79.3164L137.848 66.3243L134.459 69.7132L147.451 82.7052Z"
      fill="#F8AB5D"
    />
    <path
      d="M150.791 69.7228L147.402 66.334L134.41 79.3261L137.799 82.7149L150.791 69.7228Z"
      fill="#F8AB5D"
    />
    <path
      d="M113.279 82.6837L116.668 79.2949L103.676 66.3028L100.287 69.6916L113.279 82.6837Z"
      fill="#F8AB5D"
    />
    <path
      d="M116.666 69.7091L113.277 66.3203L100.285 79.3124L103.674 82.7011L116.666 69.7091Z"
      fill="#F8AB5D"
    />
    <path
      d="M79.1424 82.7052L82.5312 79.3164L69.5392 66.3243L66.1503 69.7132L79.1424 82.7052Z"
      fill="#F8AB5D"
    />
    <path
      d="M82.4982 69.7209L79.1094 66.332L66.1173 79.3241L69.5061 82.7129L82.4982 69.7209Z"
      fill="#F8AB5D"
    />
    <path
      d="M44.9823 82.7052L48.3711 79.3164L35.379 66.3243L31.9902 69.7132L44.9823 82.7052Z"
      fill="#F8AB5D"
    />
    <path
      d="M48.342 69.7209L44.9531 66.332L31.9611 79.3241L35.3499 82.7129L48.342 69.7209Z"
      fill="#F8AB5D"
    />
    <path
      d="M181.611 48.3752L185 44.9863L172.008 31.9942L168.619 35.3831L181.611 48.3752Z"
      fill="#F8AB5D"
    />
    <path
      d="M184.967 35.3576L181.578 31.9688L168.586 44.9608L171.975 48.3497L184.967 35.3576Z"
      fill="#F8AB5D"
    />
    <path
      d="M147.459 48.3752L150.848 44.9863L137.856 31.9942L134.467 35.3831L147.459 48.3752Z"
      fill="#F8AB5D"
    />
    <path
      d="M150.822 35.3595L147.434 31.9707L134.442 44.9628L137.83 48.3516L150.822 35.3595Z"
      fill="#F8AB5D"
    />
    <path
      d="M113.299 48.3517L116.688 44.9629L103.695 31.9708L100.307 35.3596L113.299 48.3517Z"
      fill="#F8AB5D"
    />
    <path
      d="M116.686 35.3438L113.297 31.9551L100.305 44.9472L103.694 48.3359L116.686 35.3438Z"
      fill="#F8AB5D"
    />
    <path
      d="M79.1502 48.3732L82.5391 44.9844L69.547 31.9923L66.1581 35.3811L79.1502 48.3732Z"
      fill="#F8AB5D"
    />
    <path
      d="M82.5099 35.3595L79.1211 31.9707L66.129 44.9628L69.5178 48.3516L82.5099 35.3595Z"
      fill="#F8AB5D"
    />
    <path
      d="M45.0057 48.3732L48.3945 44.9844L35.4024 31.9923L32.0136 35.3811L45.0057 48.3732Z"
      fill="#F8AB5D"
    />
    <path
      d="M48.3693 35.3595L44.9805 31.9707L31.9884 44.9628L35.3772 48.3516L48.3693 35.3595Z"
      fill="#F8AB5D"
    />
    <path
      d="M181.592 16.3986L184.98 13.0098L171.988 0.0176843L168.6 3.40652L181.592 16.3986Z"
      fill="#F8AB5D"
    />
    <path
      d="M184.967 3.40446L181.578 0.015625L168.586 13.0077L171.975 16.3965L184.967 3.40446Z"
      fill="#F8AB5D"
    />
    <path
      d="M147.443 16.4006L150.832 13.0117L137.84 0.0196374L134.451 3.40847L147.443 16.4006Z"
      fill="#F8AB5D"
    />
    <path
      d="M150.815 3.40641L147.426 0.0175781L134.434 13.0097L137.823 16.3985L150.815 3.40641Z"
      fill="#F8AB5D"
    />
    <path
      d="M113.279 16.381L116.668 12.9922L103.676 0.000106167L100.287 3.38887L113.279 16.381Z"
      fill="#F8AB5D"
    />
    <path
      d="M116.686 3.39072L113.297 0.00195312L100.305 12.994L103.694 16.3828L116.686 3.39072Z"
      fill="#F8AB5D"
    />
    <path
      d="M79.1385 16.4006L82.5273 13.0117L69.5353 0.0196374L66.1464 3.40847L79.1385 16.4006Z"
      fill="#F8AB5D"
    />
    <path
      d="M82.5099 3.40641L79.1211 0.0175781L66.129 13.0097L69.5178 16.3985L82.5099 3.40641Z"
      fill="#F8AB5D"
    />
    <path
      d="M44.9901 16.4006L48.3789 13.0117L35.3868 0.0196374L31.998 3.40847L44.9901 16.4006Z"
      fill="#F8AB5D"
    />
    <path
      d="M48.3693 3.40641L44.9805 0.0175781L31.9884 13.0097L35.3772 16.3985L48.3693 3.40641Z"
      fill="#F8AB5D"
    />
  </svg>
);

export const Shape5 = () => (
  <svg
    width="149"
    height="237"
    viewBox="0 0 149 237"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M48.941 61.1289C80.5994 71.3409 97.985 105.284 87.7732 136.942C77.5612 168.601 43.619 185.986 11.9606 175.775C-19.698 165.563 -37.0844 131.62 -26.8728 99.9619C-16.6609 68.3033 17.2824 50.917 48.941 61.1289Z"
      stroke="#242424"
      stroke-width="4"
    />
    <path
      d="M21.7031 42.5685L22.2304 42.3849C22.0539 42.4461 21.8783 42.5046 21.7031 42.5685Z"
      fill="#3D3D3D"
    />
    <path
      d="M111.307 182.367L114.695 178.979L101.703 165.986L98.3145 169.375L111.307 182.367Z"
      fill="#F8AB5D"
    />
    <path
      d="M114.693 169.359L111.305 165.971L98.3126 178.963L101.701 182.352L114.693 169.359Z"
      fill="#F8AB5D"
    />
    <path
      d="M77.158 182.387L80.5469 178.998L67.5548 166.006L64.166 169.395L77.158 182.387Z"
      fill="#F8AB5D"
    />
    <path
      d="M80.5177 169.373L77.1289 165.984L64.1368 178.976L67.5256 182.365L80.5177 169.373Z"
      fill="#F8AB5D"
    />
    <path
      d="M43.0135 182.387L46.4023 178.998L33.4103 166.006L30.0214 169.395L43.0135 182.387Z"
      fill="#F8AB5D"
    />
    <path
      d="M46.3771 169.373L42.9883 165.984L29.9962 178.976L33.385 182.365L46.3771 169.373Z"
      fill="#F8AB5D"
    />
    <path
      d="M111.283 150.395L114.672 147.006L101.68 134.014L98.291 137.403L111.283 150.395Z"
      fill="#F8AB5D"
    />
    <path
      d="M114.69 137.406L111.301 134.018L98.3087 147.01L101.697 150.398L114.69 137.406Z"
      fill="#F8AB5D"
    />
    <path
      d="M110.986 118.383L114.375 114.994L101.383 102.002L97.9942 105.391L110.986 118.383Z"
      fill="#F8AB5D"
    />
    <path
      d="M114.393 105.395L111.004 102.006L98.0118 114.998L101.401 118.387L114.393 105.395Z"
      fill="#F8AB5D"
    />
    <path
      d="M77.9862 118.381L81.375 114.992L68.3829 102L64.9942 105.389L77.9862 118.381Z"
      fill="#F8AB5D"
    />
    <path
      d="M81.3927 105.393L78.0039 102.004L65.0118 114.996L68.4006 118.385L81.3927 105.393Z"
      fill="#F8AB5D"
    />
    <path
      d="M77.1463 150.414L80.5352 147.025L67.5431 134.033L64.1542 137.422L77.1463 150.414Z"
      fill="#F8AB5D"
    />
    <path
      d="M80.5177 137.42L77.1289 134.031L64.1368 147.023L67.5257 150.412L80.5177 137.42Z"
      fill="#F8AB5D"
    />
    <path
      d="M42.9979 150.414L46.3867 147.025L33.3946 134.033L30.0058 137.422L42.9979 150.414Z"
      fill="#F8AB5D"
    />
    <path
      d="M46.3771 137.42L42.9883 134.031L29.9962 147.023L33.385 150.412L46.3771 137.42Z"
      fill="#F8AB5D"
    />
  </svg>
);

export const Shape6 = () => (
  <svg
    width="48"
    height="35"
    viewBox="0 0 48 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.2004 3.69116C28.7968 5.72661 33.3204 13.5616 31.2849 21.1579C29.2495 28.7543 21.4145 33.2779 13.8181 31.2424C6.22172 29.207 1.69818 21.372 3.73363 13.7756C5.76775 6.17886 13.6041 1.65572 21.2004 3.69116ZM14.3581 29.2272C20.8417 30.9645 27.5308 27.1025 29.2684 20.6176C31.0057 14.134 27.1437 7.44495 20.6601 5.70767C14.1752 3.97005 7.48612 7.83199 5.74885 14.3156C4.01122 20.8005 7.87317 27.4896 14.3581 29.2272Z"
      fill="#3D3D3D"
    />
    <path
      d="M44.5677 34.985L47.0469 32.5059L37.5422 23.0012L35.063 25.4804L44.5677 34.985Z"
      fill="#F8AB5D"
    />
    <path
      d="M47.03 25.4792L44.5508 23L35.0461 32.5047L37.5253 34.9838L47.03 25.4792Z"
      fill="#F8AB5D"
    />
  </svg>
);

export const Shape7 = () => (
  <svg
    width="56"
    height="47"
    viewBox="0 0 56 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.589 39.7346C8.78693 39.7346 0 30.9477 0 20.1456C0 9.34357 8.78693 0.556641 19.589 0.556641C30.3911 0.556641 39.178 9.34357 39.178 20.1456C39.1799 30.9477 30.3911 39.7346 19.589 39.7346ZM19.589 3.42228C10.3693 3.42228 2.86748 10.9241 2.86748 20.1456C2.86748 29.3653 10.3693 36.8671 19.589 36.8671C28.8105 36.8671 36.3123 29.3653 36.3123 20.1456C36.3123 10.9241 28.8105 3.42228 19.589 3.42228Z"
      fill="#3D3D3D"
    />
    <path
      d="M45.5374 46.5564L48.0195 44.0742L38.5035 34.5582L36.0214 37.0404L45.5374 46.5564Z"
      fill="#F8AB5D"
    />
    <path
      d="M48.0095 37.0388L45.5273 34.5566L36.0113 44.0726L38.4935 46.5548L48.0095 37.0388Z"
      fill="#F8AB5D"
    />
    <path
      d="M52.5325 30.5417L55.0117 28.0625L45.5071 18.5578L43.0279 21.037L52.5325 30.5417Z"
      fill="#F8AB5D"
    />
    <path
      d="M54.9948 21.0358L52.5156 18.5566L43.011 28.0613L45.4901 30.5405L54.9948 21.0358Z"
      fill="#F8AB5D"
    />
  </svg>
);

export const Shape8 = () => (
  <svg
    width="71"
    height="71"
    viewBox="0 0 71 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.4873 60.6979C20.0763 56.1489 13.7011 42.3947 18.2552 29.9816C22.8037 17.5701 36.5572 11.195 48.9697 15.7498C61.3807 20.2988 67.756 34.053 63.2018 46.466C58.6533 58.8775 44.8984 65.2469 32.4873 60.6979Z"
      fill="#F8AB5D"
    />
    <path
      d="M6.95974 41.7324C3.12182 27.4091 11.6513 12.6357 25.9746 8.79777C40.2979 4.95986 55.0712 13.4893 58.9091 27.8126C62.747 42.1359 54.2177 56.9093 39.8944 60.7472C25.5718 64.588 10.7977 56.0557 6.95974 41.7324ZM55.1081 28.8311C51.8317 16.6036 39.2205 9.32253 26.9931 12.5989C14.7657 15.8752 7.4853 28.4893 10.7609 40.7139C14.0364 52.9384 26.6485 60.2224 38.8759 56.9461C51.104 53.6726 58.3844 41.0585 55.1081 28.8311Z"
      fill="#3D3D3D"
    />
  </svg>
);

export const TopWave = () => (
  <svg
    width="100%"
    height="100%"
    id="svg"
    viewBox="0 0 1400 390"
    xmlns="http://www.w3.org/2000/svg"
    className="transition duration-300 ease-in-out delay-150"
  >
    <path
      d="M 0,400 L 0,75 C 80.55170044658192,78.84197870147716 161.10340089316384,82.68395740295432 217,87 C 272.89659910683616,91.31604259704568 304.13809687392654,96.10614908965991 378,122 C 451.86190312607346,147.8938509103401 568.3442116111302,194.89144623840605 654,216 C 739.6557883888698,237.10855376159395 794.4850566815528,232.32806595671593 856,268 C 917.5149433184472,303.67193404328407 985.715561662659,379.7962899347303 1042,408 C 1098.284438337341,436.2037100652697 1142.6526966678116,416.4867743043628 1207,428 C 1271.3473033321884,439.5132256956372 1355.6736516660942,482.2566128478186 1440,525 L 1440,400 L 0,400 Z"
      stroke="none"
      stroke-width="0"
      fill-opacity="0.3"
      className="transition-all duration-300 ease-in-out delay-150 path-0"
      transform="rotate(-180 720 200)"
      fill="#c77ff0"
    ></path>
    <path
      d="M 0,400 L 0,175 C 69.53899003778773,180.26897973205084 139.07798007557545,185.53795946410168 215,187 C 290.92201992442455,188.46204053589832 373.227069735486,186.11714187564414 435,216 C 496.772930264514,245.88285812435586 538.0137409824804,307.9934730333219 598,335 C 657.9862590175196,362.0065269666781 736.7179663345929,353.9089659910684 808,380 C 879.2820336654071,406.0910340089316 943.1143936791482,466.37066300240474 1010,495 C 1076.8856063208518,523.6293369975953 1146.8244589488147,520.6083819993129 1219,537 C 1291.1755410511853,553.3916180006871 1365.5877705255925,589.1958090003436 1440,625 L 1440,400 L 0,400 Z"
      fill="#c77ff0"
      stroke="none"
      stroke-width="0"
      fillOpacity={0.4}
      className="transition-all duration-300 ease-in-out delay-150 path-1"
      transform="rotate(-180 720 200)"
    ></path>

    <path
      d="M 0,400 L 0,275 C 74.05977327378906,255.69185846788045 148.11954654757812,236.3837169357609 228,252 C 307.8804534524219,267.6162830642391 393.5815870834765,318.1569907248368 445,344 C 496.4184129165235,369.8430092751632 513.5541051185161,370.9883201648918 586,387 C 658.4458948814839,403.0116798351082 786.2019924424596,433.889728615596 861,476 C 935.7980075575404,518.110271384404 957.6379251116455,571.4527653727242 1015,604 C 1072.3620748883545,636.5472346272758 1165.2463071109585,648.2992098935074 1242,665 C 1318.7536928890415,681.7007901064926 1379.3768464445207,703.3503950532463 1440,725 L 1440,400 L 0,400 Z"
      stroke="none"
      stroke-width="0"
      fill="#c77ff0"
      fill-opacity="0.8"
      className="transition-all duration-300 ease-in-out delay-150 path-2"
      transform="rotate(-180 720 200)"
    ></path>
  </svg>
);

export const BottomWave = () => (
  <svg
    width="100%"
    height="100%"
    id="svg"
    viewBox="0 0 1400 390"
    xmlns="http://www.w3.org/2000/svg"
    className="transition duration-300 ease-in-out delay-150"
  >
    {/* Original 3 layered blue waves */}
    <path
      d="M 0,400 L 0,75 C 66.39,73.14 132.78,71.28 207,88 C 281.21,104.71 363.25,140 437,159 C 510.74,178 576.18,180.7 635,214 C 693.81,247.3 746.01,311.2 806,329 C 865.98,346.79 933.76,318.48 1007,340 C 1080.23,361.51 1158.92,432.86 1232,472 C 1305.07,511.13 1372.53,518.06 1440,525 L 1440,400 L 0,400 Z"
      fill="#7b8af0"
      fillOpacity="0.3"
      className="transition-all duration-300 ease-in-out delay-150 path-0"
    />
    <path
      d="M 0,400 L 0,175 C 50.51,145.28 101.03,115.56 167,138 C 232.97,160.43 314.39,235.03 392,269 C 469.6,302.96 543.39,296.3 613,312 C 682.6,327.69 748.01,365.74 824,392 C 899.98,418.25 986.53,432.72 1047,451 C 1107.46,469.27 1141.84,491.36 1203,521 C 1264.15,550.63 1352.07,587.81 1440,625 L 1440,400 L 0,400 Z"
      fill="#7b8af0"
      fillOpacity="0.4"
      className="transition-all duration-300 ease-in-out delay-150 path-1"
    />
    <path
      d="M 0,400 L 0,275 C 90.18,246.78 180.36,218.56 241,242 C 301.63,265.43 332.72,340.51 385,384 C 437.27,427.48 510.75,439.37 593,453 C 675.24,466.62 766.27,481.99 829,499 C 891.72,516 926.15,534.65 999,554 C 1071.84,573.34 1183.09,593.38 1263,622 C 1342.9,650.61 1391.45,687.8 1440,725 L 1440,400 L 0,400 Z"
      fill="#7b8af0"
      fillOpacity="0.8"
      className="transition-all duration-300 ease-in-out delay-150 path-2"
    />
  </svg>
);

export const BottomWave5 = () => (
  <svg
    id="svg"
    viewBox="0 0 900 180"
    xmlns="http://www.w3.org/2000/svg"
    className="transition duration-300 ease-in-out delay-150 w-full h-auto"
  >
    <defs>
      <linearGradient id="waveGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#e3eaff" />
        <stop offset="100%" stopColor="#B6C5F5" />
      </linearGradient>
    </defs>

    {/* --- Primary tall wave (existing) --- */}
    <path
      d="M 0,800 
     L 0,50 
     C 33.2,40 66.4,30 103.5,80 
     C 140.6,140 181.6,240 218.5,290 
     C 255.37,340 288.09,360 317.5,450 
     C 346.91,540 373,680 403,730 
     C 432.99,780 466.88,710 503.5,760 
     C 540.11,810 579.46,920 616,980 
     C 652.54,1040 686.27,1060 720,1080 
     L 720,800 
     L 0,800 Z"
      fill="#7b8af0"
      fillOpacity="0.6"
      transform="scale(1.5,1.75)"
      className="tallwave-path transition-all duration-300 ease-in-out delay-150"
    />
  </svg>
);

export const BottomTallWave = () => (
  <svg
    id="svg"
    viewBox="0 0 720 180"
    xmlns="http://www.w3.org/2000/svg"
    className="transition duration-300 ease-in-out delay-150 w-full h-auto"
  >
    <defs>
      <linearGradient id="waveGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#e3eaff" />
        <stop offset="100%" stopColor="#B6C5F5" />
      </linearGradient>
    </defs>

    {/* --- Primary tall wave (existing) --- */}
    <path
      d="M 0,800 
         L 0,50 
         C 33.2,40 66.4,30 103.5,80 
         C 140.6,140 181.6,240 218.5,290 
         C 255.37,340 288.09,360 317.5,450 
         C 346.91,540 373,680 403,730 
         C 432.99,780 466.88,710 503.5,760 
         C 540.11,810 579.46,920 616,980 
         C 652.54,1040 686.27,1060 720,1080 
         L 720,800 
         L 0,800 Z"
      fill="#7b8af0"
      fillOpacity="0.6"
      className="tallwave-path transition-all duration-300 ease-in-out delay-150"
    />
  </svg>
);

export const BottomWave2 = () => (
  <svg
    id="svg"
    viewBox="0 0 400 95"
    xmlns="http://www.w3.org/2000/svg"
    className="transition duration-300 ease-in-out delay-150 w-full h-auto"
  >
    <defs>
      <linearGradient id="waveGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#e3eaff" />
        <stop offset="100%" stopColor="#B6C5F5" />
      </linearGradient>
    </defs>

    {/* --- Primary tall wave (existing) --- */}
    <path
      d="M 0,800 
         L 0,50 
         C 33.2,40 66.4,30 103.5,80 
         C 140.6,140 181.6,240 218.5,290 
         C 255.37,340 288.09,360 317.5,450 
         C 346.91,540 373,680 403,730 
         C 432.99,780 466.88,710 503.5,760 
         C 540.11,810 579.46,920 616,980 
         C 652.54,1040 686.27,1060 720,1080 
         L 720,800 
         L 0,800 Z"
      fill="#7b8af0"
      fillOpacity="0.6"
      className="tall-wave transition-all duration-300 ease-in-out delay-150"
    />
  </svg>
);

export const BottomTallWave2 = () => (
  <svg
    id="svg"
    viewBox="0 0 1000 180"
    xmlns="http://www.w3.org/2000/svg"
    className="transition duration-300 ease-in-out delay-150 w-full h-auto"
  >
    <defs>
      <linearGradient id="waveGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#e3eaff" />
        <stop offset="100%" stopColor="#B6C5F5" />
      </linearGradient>
    </defs>

    {/* --- Primary tall wave (existing) --- */}
    <path
      d="M 0,800 
     L 0,50 
     C 33.2,40 66.4,30 103.5,80 
     C 140.6,140 181.6,240 218.5,290 
     C 255.37,340 288.09,360 317.5,450 
     C 346.91,540 373,100 200,730 
     C 432.99,780 466.88,710 503.5,760 
     C 540.11,810 579.46,920 616,980 
     C 652.54,1040 686.27,1060 720,1080 
     L 720,800 
     L 0,800 Z"
      fill="#7b8af0"
      fillOpacity="0.6"
      transform="scale(1.5,1)"
      className="tallwave-path transition-all duration-300 ease-in-out delay-150"
    />
  </svg>
);

export const BottomTallWave3 = () => (
  <svg
    id="svg"
    viewBox="0 0 600 130"
    xmlns="http://www.w3.org/2000/svg"
    className="transition duration-300 ease-in-out delay-150 w-full h-auto"
  >
    <defs>
      <linearGradient id="waveGradient" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#e3eaff" />
        <stop offset="100%" stopColor="#B6C5F5" />
      </linearGradient>
    </defs>

    {/* --- Primary tall wave (existing) --- */}
    <path
      d="M 0,800 
         L 0,50 
         C 33.2,40 66.4,30 103.5,80 
         C 140.6,140 181.6,240 218.5,290 
         C 255.37,340 288.09,360 317.5,450 
         C 346.91,540 373,680 403,730 
         C 432.99,780 466.88,710 503.5,760 
         C 540.11,810 579.46,920 616,980 
         C 652.54,1040 686.27,1060 720,1080 
         L 720,800 
         L 0,800 Z"
      fill="#7b8af0"
      fillOpacity="0.6"
      className="tall-wave transition-all duration-300 ease-in-out delay-150"
    />
  </svg>
);
